var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _vm.find
        ? _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      solo: "",
                      label: _vm.label,
                      "append-icon": "mdi-magnify",
                      autofocus: "",
                    },
                    on: {
                      "click:append": function ($event) {
                        return _vm.searchItems()
                      },
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.searchItems()
                      },
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "prepend-inner",
                          fn: function () {
                            return [_vm._t("optionsFilter")]
                          },
                          proxy: true,
                        },
                        _vm.showAppend
                          ? {
                              key: "append",
                              fn: function () {
                                return [
                                  _vm._t("append"),
                                  _vm.showFilter
                                    ? _c(
                                        "v-tooltip",
                                        {
                                          attrs: { bottom: "" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function ({ on, attrs }) {
                                                  return [
                                                    _c(
                                                      "v-btn",
                                                      _vm._g(
                                                        _vm._b(
                                                          {
                                                            attrs: {
                                                              color:
                                                                _vm.payloadFilter
                                                                  ? "primary"
                                                                  : "grey",
                                                              icon: "",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                $event.preventDefault()
                                                                $event.stopPropagation()
                                                                return _vm.$emit(
                                                                  "click-filter"
                                                                )
                                                              },
                                                            },
                                                          },
                                                          "v-btn",
                                                          attrs,
                                                          false
                                                        ),
                                                        on
                                                      ),
                                                      [
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            attrs: { btn: "" },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.payloadFilter
                                                                  ? "mdi-filter-menu-outline"
                                                                  : "mdi-filter-outline"
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            false,
                                            2085373195
                                          ),
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(" Demais Filtros "),
                                          ]),
                                        ]
                                      )
                                    : _vm._e(),
                                  _c(
                                    "v-tooltip",
                                    {
                                      attrs: { bottom: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function ({ on, attrs }) {
                                              return [
                                                _c(
                                                  "v-btn",
                                                  _vm._g(
                                                    _vm._b(
                                                      {
                                                        attrs: { icon: "" },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            $event.preventDefault()
                                                            $event.stopPropagation()
                                                            return _vm.searchItems()
                                                          },
                                                        },
                                                      },
                                                      "v-btn",
                                                      attrs,
                                                      false
                                                    ),
                                                    on
                                                  ),
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      { attrs: { btn: "" } },
                                                      [_vm._v("mdi-magnify")]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        772344466
                                      ),
                                    },
                                    [_c("span", [_vm._v(" Pesquisar ")])]
                                  ),
                                ]
                              },
                              proxy: true,
                            }
                          : null,
                      ],
                      null,
                      true
                    ),
                    model: {
                      value: _vm.search,
                      callback: function ($$v) {
                        _vm.search = $$v
                      },
                      expression: "search",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c("v-data-table", {
        attrs: {
          headers: _vm.headerItems,
          items: _vm.collections,
          "item-key": _vm.itemKey,
          options: _vm.options,
          "server-items-length": _vm.total,
          page: _vm.meta.page,
          "items-per-page": _vm.options.itemsPerPage,
          "footer-props": _vm.footerProps,
          loading: _vm.loadingText.length > 0,
          "loading-text": _vm.loadingText,
          "fixed-header": "",
          height: _vm.tableHeight,
          "custom-filter": _vm.customFilter,
          "item-class": _vm.rowClass,
          "single-select": _vm.singleSelect,
          "show-select": _vm.showSelect,
          "aria-label": "Tabela de dados",
        },
        on: {
          "update:options": function ($event) {
            _vm.options = $event
          },
          "update:page": function ($event) {
            return _vm.$set(_vm.meta, "page", $event)
          },
          "page-count": function ($event) {
            _vm.count = $event
          },
        },
        scopedSlots: _vm._u(
          [
            _vm._l(Object.keys(_vm.$scopedSlots), function (slot) {
              return {
                key: slot,
                fn: function (scope) {
                  return [_vm._t(slot, null, null, scope)]
                },
              }
            }),
            _vm._l(_vm.headersDate, function (h, index) {
              return {
                key: `item.${h.value}`,
                fn: function ({ item }) {
                  return [
                    h.type == "date"
                      ? _c("span", { key: index }, [
                          h.range
                            ? _c("span", [
                                _vm._v(
                                  " " + _vm._s(_vm._f("date")(item[h.value[0]]))
                                ),
                                item[h.value[1]]
                                  ? _c("span", [
                                      h.breakrow
                                        ? _c("br")
                                        : _c("span", [_vm._v(" - ")]),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm._f("date")(item[h.value[1]])
                                          )
                                      ),
                                    ])
                                  : _vm._e(),
                              ])
                            : _c("span", [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm._f("date")(item[h.value])) +
                                    " "
                                ),
                              ]),
                        ])
                      : h.type == "dateTime"
                      ? _c("span", { key: index }, [
                          _vm._v(_vm._s(_vm._f("dateTime")(item[h.value]))),
                        ])
                      : h.type == "icon"
                      ? _c(
                          "span",
                          { key: index },
                          [_c("v-icon", [_vm._v(_vm._s(item[h.value]))])],
                          1
                        )
                      : h.type == "html"
                      ? _c("span", { key: index }, [
                          _c("span", {
                            domProps: { innerHTML: _vm._s(item[h.value]) },
                          }),
                        ])
                      : h.type == "boolean"
                      ? _c("span", { key: index }, [
                          _vm.showIconBoolean
                            ? _c(
                                "span",
                                {
                                  staticClass: "status-indicator",
                                  class: item[h.value]
                                    ? "status-indicator--success"
                                    : "status-indicator--error",
                                },
                                [
                                  item[h.value]
                                    ? _c(
                                        "v-icon",
                                        {
                                          attrs: {
                                            small: "",
                                            color: "success",
                                            "aria-hidden": "true",
                                          },
                                        },
                                        [_vm._v("mdi-check-bold")]
                                      )
                                    : _c(
                                        "v-icon",
                                        {
                                          attrs: {
                                            small: "",
                                            color: "error",
                                            "aria-hidden": "true",
                                          },
                                        },
                                        [_vm._v("mdi-close-thick")]
                                      ),
                                  _c("span", { staticClass: "sr-only" }, [
                                    _vm._v(
                                      _vm._s(item[h.value] ? "Sim" : "Não")
                                    ),
                                  ]),
                                ],
                                1
                              )
                            : _c("span", [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm._f("boolean")(item[h.value])) +
                                    " "
                                ),
                              ]),
                        ])
                      : h.type == "time"
                      ? _c("span", { key: index }, [
                          h.range
                            ? _c("span", [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm._f("time")(item[h.value[0]])) +
                                    " - " +
                                    _vm._s(_vm._f("time")(item[h.value[1]])) +
                                    " "
                                ),
                              ])
                            : _c("span", [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm._f("time")(item[h.value])) +
                                    " "
                                ),
                              ]),
                        ])
                      : h.type == "array"
                      ? _c(
                          "span",
                          { key: index },
                          [
                            _c(
                              "v-tooltip",
                              {
                                attrs: { bottom: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function ({ on, attrs }) {
                                        return [
                                          _c(
                                            "span",
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  staticStyle: {
                                                    cursor: "help",
                                                  },
                                                },
                                                "span",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  item[h.value]
                                                    .map((o) => o["initials"])
                                                    .join(", ")
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        item[h.value]
                                          .map((o) => o["name"])
                                          .join(", ")
                                      ) +
                                      " "
                                  ),
                                ]),
                              ]
                            ),
                          ],
                          1
                        )
                      : h.type == "money"
                      ? _c("span", { key: index }, [
                          _vm._v(
                            " " + _vm._s(_vm._f("money")(item[h.value])) + " "
                          ),
                        ])
                      : h.type == "initials"
                      ? _c(
                          "span",
                          { key: index },
                          [
                            _c(
                              "v-tooltip",
                              {
                                attrs: { bottom: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function ({ on, attrs }) {
                                        return [
                                          _c(
                                            "span",
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  staticStyle: {
                                                    cursor: "help",
                                                  },
                                                },
                                                "span",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  item[h.value]["initials"]
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    " " + _vm._s(item[h.value]["name"]) + " "
                                  ),
                                ]),
                              ]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                },
              }
            }),
            {
              key: "item.active",
              fn: function ({ item }) {
                return [
                  item.active
                    ? _c(
                        "v-chip",
                        {
                          attrs: {
                            color: "success",
                            dark: "",
                            "x-small": "",
                            "aria-label": "Status: Ativo",
                          },
                        },
                        [
                          _c(
                            "v-icon",
                            {
                              attrs: {
                                "x-small": "",
                                left: "",
                                "aria-hidden": "true",
                              },
                            },
                            [_vm._v("mdi-check-circle")]
                          ),
                          _vm._v(" Ativo "),
                        ],
                        1
                      )
                    : _c(
                        "v-chip",
                        {
                          attrs: {
                            color: "error",
                            dark: "",
                            "x-small": "",
                            "aria-label": "Status: Inativo",
                          },
                        },
                        [
                          _c(
                            "v-icon",
                            {
                              attrs: {
                                "x-small": "",
                                left: "",
                                "aria-hidden": "true",
                              },
                            },
                            [_vm._v("mdi-close-circle")]
                          ),
                          _vm._v(" Inativo "),
                        ],
                        1
                      ),
                ]
              },
            },
            _vm.showActions
              ? {
                  key: "item.actions",
                  fn: function ({ item }) {
                    return [
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex flex-row flex-nowrap align-center justify-center",
                        },
                        [
                          _vm._t("actions", null, { item: item }),
                          !_vm.hideEdit
                            ? _c("emc-table-icon-edit", {
                                attrs: {
                                  icon: _vm.iconEdit,
                                  "tool-tip": _vm.toolTipEdit,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.updateItem(item)
                                  },
                                },
                              })
                            : _vm._e(),
                          _vm.shouldShowDelete(item)
                            ? _c("emc-table-icon-delete", {
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteItem(item)
                                  },
                                },
                              })
                            : _vm._e(),
                        ],
                        2
                      ),
                    ]
                  },
                }
              : null,
          ],
          null,
          true
        ),
        model: {
          value: _vm.selected,
          callback: function ($$v) {
            _vm.selected = $$v
          },
          expression: "selected",
        },
      }),
      _c("emc-loader-progress", { attrs: { show: _vm.loading } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }